import { ModuleConfig } from '../../models/module';
import { IAM_USER_RESOURCE_NAME } from './models/iam-user';

export const config: ModuleConfig = {
  moduleName: IAM_USER_RESOURCE_NAME,
  redux: {},
  listenerSagas: [],
  routes: {},
};
